import React, { useEffect, useState } from 'react';
import styles from '../../../styles/adminEvents.module.css';
import ConfirmModal from '../../../shared/components/ConfirmModal';
import { Navigate } from "react-router-dom";
import { requesturl } from '../../../shared/utils/requesturl';

const BLOGS_API = `${requesturl}blogs.php`;
export default function Adminblogs() {
  const [events, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [form, setForm] = useState({ title: '',content : '', details: '', date: '' });
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  function fetchBlogs() {
    setLoading(true);
    fetch(BLOGS_API)
      .then((r) => r.json())
      .then((data) => {
        setBlogs(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch((e) => { setError('Failed to load blogs'); setLoading(false); console.error(e); });
  }

  useEffect(() => { fetchBlogs(); }, []);

  function handleChange(e) {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
    // clear messages on change
    setMessage('');
    setMessageType('');
  }





  function handleSubmit(e) {
    e.preventDefault();
    // client-side validation
    if (!form.title.trim()) {
      setMessage('Title is required'); setMessageType('error'); return;
    }

    setSubmitting(true);
    const payload = { action: 'add', title: form.title, details:form.details, content:form.content };
    fetch(BLOGS_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then((r) => r.text())
      .then((data) => {
        // if API returns the created event, append it; else just refetch
        if (data && data.title) setBlogs((evs) => [...evs, data]);
        else fetchBlogs();
        setForm({ title: '', content: '', details: ''});
        setMessage('Blog added'); setMessageType('success');
      })
      .catch(() => setError('Failed to add Blog'))
      .finally(() => setSubmitting(false));
  }
  // pending deletion id for modal confirm
  const [pendingDelete, setPendingDelete] = useState(null);

  function handleDelete(id) {
      fetch(BLOGS_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action: 'delete', id }),
    })
      .then((r) => r.text())
      .then((data) => {
        if (data && data.success) setBlogs((evs) => evs.filter((e) => e.id !== id));
        else fetchBlogs();
        setMessage('Event deleted'); setMessageType('success');
        console.log(data);
      })
      .catch((e) => setError('Failed to delete'));
  }

  function confirmDelete() {
    if (!pendingDelete) return;
    handleDelete(pendingDelete);
    setPendingDelete(null);
  }

  function cancelDelete() {
    setPendingDelete(null);
  }

 if( sessionStorage.getItem('isAdmin') === 'true'){ 
   return (
  <div className={styles.wrapper}>
      <h3 className={styles.title}>Admin: Manage Events</h3>

      <form onSubmit={handleSubmit} className={styles.form}>
        <label className={styles.fullWidth}>Title
          <input name="title" type='text' value={form.title} onChange={handleChange} required />
        </label>
        <label className={styles.fullWidth}>Introduction *
          <input name="details" type="Text" value={form.details} onChange={handleChange} required />
        </label>
        <label className={styles.fullWidth}>Content 
          <textarea name="content" type="text" value={form.content} onChange={handleChange} required />
        </label>
        <button type="submit" className={styles.submit} disabled={submitting}>{submitting ? 'Adding...' : 'Add Event'}</button>
      </form>

      {message && (
        <div className={`${styles.message} ${messageType === 'error' ? styles.messageError : styles.messageSuccess}`} role="status">
          {message}
        </div>
      )}

      <div className={styles.list}>
        <h4>Existing events</h4>
        {loading && <div>Loading...</div>}
        {error && <div className={styles.error}>{error}</div>}
        {!loading && events.length === 0 && <div>No events</div>}
        <ul>
          {events.map((ev) => (
            <li key={ev.id} className={styles.eventItem}>
              <div className={styles.meta}>
                <div className={styles.evTitle} >{ev.title}</div>
                <div className={styles.evRange}>{ev.date}</div>
              </div>
              <div>
                <button className={styles.delete} onClick={() => setPendingDelete(ev.id)}>Delete</button>
              </div>
            </li>
          ))}
        </ul>
      </div>
      <ConfirmModal
        isOpen={Boolean(pendingDelete)}
        title="Delete event"
        message="Are you sure you want to delete this event? This cannot be undone."
        onConfirm={confirmDelete}
        onCancel={cancelDelete}
      />
    </div>
   )

  }

  return <Navigate to="/admin" replace />;


}
